"use strict";
/// <reference path="irep.js"/>

IREP.editprofile = (function () {
    var ddlCountry;
    var ddlCompany;
    var ddlLanguage;
    var txtCompanyInput;
    var hfAccountChange, txtBio, txtFirstName, txtLastName, txtEmail, txtPassword, txtPasswordConfirm, txtAddress, txtCity,
        txtPostal, txtPhone, txtRCISCode, ddlStateBrazil, ddlCityBrazil, mtrRetailChainMissing, mtrFirstNameMissing,
        mtrLastNameMissing, mtrEmailMissing, mtrIncorrectEmail, mtrPasswordNotMatch, mtrPasswordMustBe, mtrAddressMissing,
        mtrCityMissing, mtrZipCodeMissing, mtrPhoneMissing, mtrFailure, mtrSuccess, trAddress, trAddress2, trCity, trProvince, trPostal,
        txtStoreAddress, txtStoreAddress2, txtAddress2, txtStoreZip, drp2Province, ddlProvince, txtStorePhone, drpRetailerApac, ddlPosition, 
        radDisplayName, radShareInfo, radFocusGroups, radSurveys, radPersonalMessaging, radReceiveEmail, ddlStore,
        mtrPleaseSelect, mtrChainNotListed, mtrStoreNotListed, drp2City, drpStoreApac, txtStoreCity, txtStoreZip, txtStoreCode, drpStoreSearchApac, ddlShirtSize,
        txtEmployeeCode, txtHomePhone, radOptInFiveStar;
        
    var IntelIdClicked = 0;
    var init = function (options) {
        var dataObj = {};
        dataObj.UserType = IREP.options.user.userType;
        dataObj.Site = IREP.options.user.site;
        dataObj.CountryCode = IREP.options.user.countryCode;
        ddlCountry = options.ddlCountry;
        ddlCompany = options.ddlCompany;
        ddlLanguage = options.ddlLanguage;
        txtCompanyInput = options.txtCompanyInput;
        hfAccountChange = options.hfAccountChange;
        txtBio = options.txtBio;
        txtEmail = options.txtEmail;
        txtPassword = options.txtPassword;
        txtPasswordConfirm = options.txtPasswordConfirm;
        txtAddress = options.txtAddress;
        txtCity = options.txtCity;
        txtPostal = options.txtPostal;
        txtPhone = options.txtPhone;
        txtRCISCode = options.txtRCISCode;
        ddlStateBrazil = options.ddlStateBrazil;
        ddlCityBrazil = options.ddlCityBrazil;
        mtrRetailChainMissing = options.mtrRetailChainMissing;
        mtrEmailMissing = options.mtrEmailMissing;
        mtrIncorrectEmail = options.mtrIncorrectEmail;
        mtrPasswordNotMatch = options.mtrPasswordNotMatch;
        mtrPasswordMustBe = options.mtrPasswordMustBe;
        mtrAddressMissing = options.mtrAddressMissing;
        mtrCityMissing = options.mtrCityMissing;
        mtrZipCodeMissing = options.mtrZipCodeMissing;
        mtrPhoneMissing = options.mtrPhoneMissing;
        mtrFailure = options.mtrFailure;
        mtrSuccess = options.mtrSuccess;
        trAddress = options.trAddress;
        trAddress2 = options.trAddress2;
        trCity = options.trCity;
        trProvince = options.trProvince;
        trPostal = options.trPostal;
        txtStoreAddress = options.txtStoreAddress;
        txtAddress2 = options.txtAddress2;
        txtStoreZip = options.txtStoreZip;
        drp2Province = options.drp2Province;
        ddlProvince = options.ddlProvince;
        txtStorePhone = options.txtStorePhone;
        drpRetailerApac = options.drpRetailerApac;
        ddlPosition = options.ddlPosition;
        radDisplayName = options.radDisplayName;
        radShareInfo = options.radShareInfo;

        radFocusGroups = options.radFocusGroups;
        radSurveys = options.radSurveys;
        radPersonalMessaging = options.radPersonalMessaging;
        radReceiveEmail = options.radReceiveEmail;
        ddlStore = options.ddlStore;
        mtrPleaseSelect = options.mtrPleaseSelect;
        mtrChainNotListed = options.mtrChainNotListed;
        mtrStoreNotListed = options.mtrStoreNotListed;
        drp2City = options.drp2City;
        drpStoreApac = options.drpStoreApac;
        txtStoreZip = options.txtStoreZip;
        txtStoreCity = options.txtStoreCity;
        txtStoreCode = options.txtStoreCode;
        drpStoreSearchApac = options.drpStoreSearchApac;
        ddlShirtSize = options.ddlShirtSize;
        txtEmployeeCode = options.txtEmployeeCode;
        txtHomePhone = options.txtHomePhone;
        radOptInFiveStar = options.radOptInFiveStar;

        AccountCheck(true);
        CheckRows();
        $('input:radio').change(function (e) {
            AccountCheck();
        });
        $(txtBio).change(function (e) {
            AccountCheck();
        });

        if (IREP.options.user.geoCode == 'PRC' && 104 !== IREP.options.user.userTypeId) {
            $('#tblAPACFilter').show()
            $('#storeSearch').hide()
            //GetStoreChains();
            ShowStoreInfo()
        } else {
            $('#tblAPACFilter').hide()
            $('#storeSearch').show()
            $('#divStoreSearch').hide();
            $('#PRCStoreSearch').css('padding-top', '0px').css('padding-bottom', '0px');
        }

        if(IREP.options.user.site == "DMR")
        {
            $('#shareInfoWithCompany').hide();
        }

        $(window).keydown(function (event) {
            if (event.keyCode == 13) {
                event.preventDefault();

                if ($("#divEditProfilePlaceHolder").css("display") === "block")
                {
                    CheckRows();
                    if (($('#divError').is(":visible") != true)) {
                        if ($(hfAccountChange).val() == 1) {
                            if (AccountCheck() == false) { //if false, do not allow save to continue
                                return false;
                            }
                        }
                    }

                    var objAccount = {
                        PaxUID: IREP.options.user.currentUID,
                        Bio: $(options.txtBio).val(),
                        HomeCountryCode: $(options.ddlCountry).val(),
                        CellPhoneNumber: $(options.txtPhone).val(),
                        EmailAddress: $(options.txtEmail).val(),
                        OrigEmailAddress: IREP.options.user.email,
                        CultureCode: $(options.ddlLanguage).val(),
                        Password: $(options.txtPassword).val(),
                        RetailChainId: 0,
                        StorePosition: $(options.ddlPosition).val(),
                        UserType: IREP.options.user.userType,
                        GeoCode: IREP.options.user.geoCode
                    };

                    if (objAccount.GeoCode == "ASMO") {
                        objAccount.ShirtSize = $(ddlShirtSize).val();
                        objAccount.EmployeeCode = $(txtEmployeeCode).val();
                        objAccount.HomePhoneNumber = $(txtHomePhone).val();
                        objAccount.HomeAddress2 = $.trim($(txtAddress2).val());
                        if ($(radOptInFiveStar).is(':checked')) objAccount.OptInFiveStar = 1;
                        else objAccount.OptInFiveStar = 0;
                    }

                    if ((objAccount.GeoCode == "PRC") && (104 !== IREP.options.user.userTypeId)) {
                        objAccount.HomeAddress1 = $.trim($(txtStoreAddress).val());
                        objAccount.HomeAddress2 = $.trim($(txtStoreAddress2).val());
                        objAccount.HomeCity = $.trim($(txtStoreCity).val());
                        objAccount.HomeZipCode = $.trim($(txtStoreZip).val());
                        objAccount.HomeStateCode = $(drp2Province).val();
                        objAccount.HomePhoneNumber = $.trim($(txtStorePhone).val());
                        objAccount.StoreCode = $.trim($(txtStoreCode).val());
                    }
                    else {
                        objAccount.HomeAddress1 = $.trim($(txtAddress).val());
                        objAccount.HomeAddress2 = $.trim($(txtAddress2).val());
                        objAccount.HomeCity = $.trim($(txtCity).val());
                        objAccount.HomeZipCode = $.trim($(txtPostal).val());
                        objAccount.HomeStateCode = $.trim($(ddlProvince).val());
                        objAccount.HomePhoneNumber = $.trim($(txtHomePhone).val());
                    }

                    objAccount.BrState = 0;
                    objAccount.BrCity = 0;

                    if (IREP.options.user.countryCode == "BR") {
                        objAccount.BrState = $(ddlStateBrazil).val();
                        objAccount.BrCity = $(ddlCityBrazil).val();
                        if (objAccount.BrState == "") { objAccount.BrState = 0; }
                        if (objAccount.BrCity == "") { objAccount.BrCity = 0; }
                    }

                    if ((objAccount.GeoCode == "PRC") && (104 !== IREP.options.user.userTypeId)) {
                        objAccount.StoreChainId = $(drpRetailerApac).val();
                    }
                    else if ((objAccount.GeoCode == "APAC") || (objAccount.GeoCode == "EMEA") || (objAccount.GeoCode == "LAR")) {
                        objAccount.StoreChainId = "0"; //ITP
                    }
                    else {
                        objAccount.StoreChainId = $(ddlCompany).val();
                    }
                    if ((objAccount.GeoCode == "PRC") && (104 !== IREP.options.user.userTypeId)) {
                        objAccount.StoreNumber = $(drpStoreApac).val();
                        if (IntelIdClicked == 1)
                            objAccount.StoreNumber = $(drpStoreSearchApac).val();
                        objAccount.StoreCode = objAccount.StoreNumber;
                        if (objAccount.StoreNumber == "1") {
                            objAccount.StoreCode = "-1";
                        }
                    }
                    else {

                        if ("APAC|EMEA|LAR".indexOf(IREP.options.user.geoCode) >= 0) {
                            objAccount.StoreNumber = $(txtCompanyInput).val();
                            if (objAccount.StoreNumber == "") {
                                objAccount.StoreNumber = options.storeId;
                            }
                        }

                        else {
                            objAccount.StoreNumber = $(ddlStore).val();
                        }
                        objAccount.StoreCode = objAccount.StoreNumber;
                    }

                    if ($(radReceiveEmail).is(':checked')) objAccount.ReceiveUpdatesTypeId = 68;
                    else objAccount.ReceiveUpdatesTypeId = 69;

                    if ((objAccount.GeoCode != "asmo") && (objAccount.GeoCode != "isep")) {
                        if ($(radPersonalMessaging).is(':checked'))
                            objAccount.PersonalMessaging = 1;
                        else objAccount.PersonalMessaging = 0;
                    }

                    objAccount.AllowFriends = 1;

                    if ($(radShareInfo).is(':checked')) objAccount.ShareInfo = 1;
                    else objAccount.ShareInfo = 0;

                    if (IREP.options.user.site == "DMR") {
                        objAccount.ShareInfo = 1;
                    }

                    if ($(radDisplayName).is(':checked')) objAccount.DisplayInfoOnSite = 1;
                    else objAccount.DisplayInfoOnSite = 0;

                    if ($(radSurveys).is(':checked')) objAccount.OptInSurvey = 1;
                    else objAccount.OptInSurvey = 0;

                    if ($(radFocusGroups).is(':checked')) objAccount.OptInFocusGroup = 1;
                    else objAccount.OptInFocusGroup = 0;

                    objAccount.CorporateOffice = 32;

                    var cn = $(ddlCountry).val();

                    if ((cn.toLowerCase() == "us") || (cn.toLowerCase() == "ca")) {
                        objAccount.GeoCode = "ASMO";
                    } else if ((cn.toLowerCase() == "ar") || (cn.toLowerCase() == "br") || (cn.toLowerCase() == "cl") || (cn.toLowerCase() == "co") || (cn.toLowerCase() == "cr") || (cn.toLowerCase() == "do") || (cn.toLowerCase() == "ec") || (cn.toLowerCase() == "gt") || (cn.toLowerCase() == "mx") || (cn.toLowerCase() == "ni") || (cn.toLowerCase() == "pa") || (cn.toLowerCase() == "pe") || (cn.toLowerCase() == "sv") || (cn.toLowerCase() == "uy") || (cn.toLowerCase() == "ve")) {
                        objAccount.GeoCode = "LAR";
                    } else if ((cn.toLowerCase() == "au") || (cn.toLowerCase() == "cn") || (cn.toLowerCase() == "id") || (cn.toLowerCase() == "in") || (cn.toLowerCase() == "kr") || (cn.toLowerCase() == "lk") || (cn.toLowerCase() == "mn") || (cn.toLowerCase() == "my") || (cn.toLowerCase() == "nz") || (cn.toLowerCase() == "ph") || (cn.toLowerCase() == "pk") || (cn.toLowerCase() == "sg") || (cn.toLowerCase() == "th") || (cn.toLowerCase() == "tw") || (cn.toLowerCase() == "vn")) {
                        objAccount.GeoCode = "APAC";
                    } else {
                        objAccount.GeoCode = "EMEA";
                    }
                    if (objAccount.HomeStateCode == "") { objAccount.HomeStateCode = null; }

                    if ((($(ddlCountry).val().toUpperCase() == "BR") && (objAccount.BrState != 0) && (objAccount.BrCity != 0))) {
                        objAccount.HomeStateCode = objAccount.BrState;
                        objAccount.HomeCity = objAccount.BrCity;
                    } else {
                        if ($(txtCity).val() !== undefined) {
                            objAccount.HomeCity = $(txtCity).val();
                        }
                        if ($(ddlProvince).val() !== undefined) {
                            objAccount.HomeStateCode = $(ddlProvince).val();
                        }
                    }

                    if (AccountCheck() == true) {
                        if (objAccount.EmailAddress != "") {
                            IREP.leaderboard.block($("#divEditProfile"));
                            IREP.callApi({ url: "account/save", type: "POST", data: objAccount, secure: true })
                                .done(function () {
                                    //IREP.dashboard.ExpandCollapse();
                                    $("#divError").html(mtrSuccess); $("#divError").show();
                                    IREP.dashboard.RefreshParticipantInfo();
                                    ($("#divEditProfile")).unblock();
                                })
                                .fail(function (data) {
                                    $("#divError").html(mtrFailure); $("#divError").show();
                                    ($("#divEditProfile")).unblock();
                                })
                        }
                    }
                }

                

                return false;
            }
        });

        $("#divSaveProfile").click(function () {
            CheckRows();
            if (($('#divError').is(":visible") != true)) {
                if ($(hfAccountChange).val() == 1) {
                    if (AccountCheck() == false) { //if false, do not allow save to continue
                        return false;
                    }                     
                }
            }    

            var objAccount = {
                PaxUID: IREP.options.user.currentUID,
                Bio: $(options.txtBio).val(),
                HomeCountryCode: $(options.ddlCountry).val(),
                CellPhoneNumber: $(options.txtPhone).val(),
                EmailAddress: $(options.txtEmail).val(),
                OrigEmailAddress: IREP.options.user.email,
                CultureCode: $(options.ddlLanguage).val(),
                Password: $(options.txtPassword).val(),
                RetailChainId: 0,
                StorePosition: $(options.ddlPosition).val(),
                UserType: IREP.options.user.userType,
                GeoCode: IREP.options.user.geoCode
            };

            if (objAccount.GeoCode == "ASMO") {
                objAccount.ShirtSize = $(ddlShirtSize).val();
                objAccount.EmployeeCode = $(txtEmployeeCode).val();
                objAccount.HomePhoneNumber = $(txtHomePhone).val();
                objAccount.HomeAddress2 = $.trim($(txtAddress2).val());
                if ($(radOptInFiveStar).is(':checked')) objAccount.OptInFiveStar = 1;
                else objAccount.OptInFiveStar = 0;
            }

            if ((objAccount.GeoCode == "PRC") && (104 !== IREP.options.user.userTypeId))
            {
                objAccount.HomeAddress1 = $.trim($(txtStoreAddress).val());
                objAccount.HomeAddress2 = $.trim($(txtStoreAddress2).val());
                objAccount.HomeCity = $.trim($(txtStoreCity).val());
                objAccount.HomeZipCode = $.trim($(txtStoreZip).val());
                objAccount.HomeStateCode = $(drp2Province).val();
                objAccount.HomePhoneNumber = $.trim($(txtStorePhone).val());
                objAccount.StoreCode = $.trim($(txtStoreCode).val());
            }
            else {
                objAccount.HomeAddress1 = $.trim($(txtAddress).val());
                objAccount.HomeAddress2 = $.trim($(txtAddress2).val());
                objAccount.HomeCity = $.trim($(txtCity).val());
                objAccount.HomeZipCode = $.trim($(txtPostal).val());
                objAccount.HomeStateCode = $.trim($(ddlProvince).val());
                objAccount.HomePhoneNumber = $.trim($(txtHomePhone).val());
            }

            objAccount.BrState = 0;
            objAccount.BrCity = 0;

            if (IREP.options.user.countryCode == "BR") {
                objAccount.BrState = $(ddlStateBrazil).val();
                objAccount.BrCity = $(ddlCityBrazil).val();
                if (objAccount.BrState == "") { objAccount.BrState = 0; }
                if (objAccount.BrCity == "") { objAccount.BrCity = 0; }
            } 

            if ((objAccount.GeoCode == "PRC") && (104 !== IREP.options.user.userTypeId)) {
                objAccount.StoreChainId	= $(drpRetailerApac).val();
            } 
            else if ((objAccount.GeoCode == "APAC") || (objAccount.GeoCode == "EMEA") || (objAccount.GeoCode == "LAR")) {
                objAccount.StoreChainId	= "0"; //ITP
            } 
            else {
                objAccount.StoreChainId	= $(ddlCompany).val();
            }
            if ((objAccount.GeoCode == "PRC") && (104 !== IREP.options.user.userTypeId)) {
                objAccount.StoreNumber = $(drpStoreApac).val();
                if (IntelIdClicked == 1)
                    objAccount.StoreNumber = $(drpStoreSearchApac).val();
                objAccount.StoreCode = objAccount.StoreNumber;
                if (objAccount.StoreNumber == "1") {
                    objAccount.StoreCode = "-1";
                }
            } 
            else {

                if ("APAC|EMEA|LAR".indexOf(IREP.options.user.geoCode) >= 0) {
                    objAccount.StoreNumber = $(txtCompanyInput).val();
                    if (objAccount.StoreNumber == "") {
                        objAccount.StoreNumber = options.storeId;
                    }
                }

		        else {
                    objAccount.StoreNumber = $(ddlStore).val();
                }
                objAccount.StoreCode = objAccount.StoreNumber;
            }

            if ($(radReceiveEmail).is(':checked')) objAccount.ReceiveUpdatesTypeId = 68;
            else objAccount.ReceiveUpdatesTypeId = 69;

            if ((objAccount.GeoCode != "asmo") && (objAccount.GeoCode != "isep")) {
                if ($(radPersonalMessaging).is(':checked'))
                    objAccount.PersonalMessaging = 1;
                else objAccount.PersonalMessaging = 0;
            }

            objAccount.AllowFriends = 1;

            if ($(radShareInfo).is(':checked')) objAccount.ShareInfo = 1;
            else objAccount.ShareInfo = 0;

            if (IREP.options.user.site == "DMR")
            {                
                objAccount.ShareInfo = 1;
            }

            if ($(radDisplayName).is(':checked')) objAccount.DisplayInfoOnSite = 1;
            else objAccount.DisplayInfoOnSite = 0;

            if ($(radSurveys).is(':checked')) objAccount.OptInSurvey = 1;
            else objAccount.OptInSurvey = 0;

            if ($(radFocusGroups).is(':checked')) objAccount.OptInFocusGroup = 1;
            else objAccount.OptInFocusGroup = 0;

            objAccount.CorporateOffice = 32;

            var cn = $(ddlCountry).val();

            if ((cn.toLowerCase() == "us") || (cn.toLowerCase() == "ca")) {
                objAccount.GeoCode = "ASMO";
            } else if ((cn.toLowerCase() == "ar") || (cn.toLowerCase() == "br") || (cn.toLowerCase() == "cl") || (cn.toLowerCase() == "co") || (cn.toLowerCase() == "cr") || (cn.toLowerCase() == "do") || (cn.toLowerCase() == "ec") || (cn.toLowerCase() == "gt") || (cn.toLowerCase() == "mx") || (cn.toLowerCase() == "ni") || (cn.toLowerCase() == "pa") || (cn.toLowerCase() == "pe") || (cn.toLowerCase() == "sv") || (cn.toLowerCase() == "uy") || (cn.toLowerCase() == "ve")) {
                objAccount.GeoCode = "LAR";
            } else if ((cn.toLowerCase() == "au") || (cn.toLowerCase() == "cn") || (cn.toLowerCase() == "id") || (cn.toLowerCase() == "in") || (cn.toLowerCase() == "kr") || (cn.toLowerCase() == "lk") || (cn.toLowerCase() == "mn") || (cn.toLowerCase() == "my") || (cn.toLowerCase() == "nz") || (cn.toLowerCase() == "ph") || (cn.toLowerCase() == "pk") || (cn.toLowerCase() == "sg") || (cn.toLowerCase() == "th") || (cn.toLowerCase() == "tw") || (cn.toLowerCase() == "vn")) {
                objAccount.GeoCode = "APAC";
            } else {
                objAccount.GeoCode = "EMEA";
            }
            if (objAccount.HomeStateCode == "") { objAccount.HomeStateCode = null; }

            if ((($(ddlCountry).val().toUpperCase() == "BR") && (objAccount.BrState != 0) && (objAccount.BrCity != 0))) {
                objAccount.HomeStateCode = objAccount.BrState;
                objAccount.HomeCity = objAccount.BrCity;
            } else {
                if ($(txtCity).val() !== undefined) {
                    objAccount.HomeCity = $(txtCity).val();
                }
                if ($(ddlProvince).val() !== undefined) {
                    objAccount.HomeStateCode = $(ddlProvince).val();
                }
            }

            if (AccountCheck() == true) {
                if (objAccount.EmailAddress != "") {
                    IREP.leaderboard.block($("#divEditProfile"));
                    IREP.callApi({ url: "account/save", type: "POST", data: objAccount, secure: true })
                        .done(function () {
                            //IREP.dashboard.ExpandCollapse();
                            $("#divError").html(mtrSuccess); $("#divError").show();
                            IREP.dashboard.RefreshParticipantInfo();
                            ($("#divEditProfile")).unblock();
                        })
                        .fail(function (data) {
                            $("#divError").html(mtrFailure);$("#divError").show();
                            ($("#divEditProfile")).unblock();
                        })
                }
            }
            return false;
        });

    };

    var AccountCheck = function(pageLoad) {
        
        var b = true;
        var hf	= $.trim($(hfAccountChange).val());
        var cn	= $(ddlCountry).val();
        var e	= $.trim($(txtEmail).val());
        var pw	= $.trim($(txtPassword).val());
        var pc	= $.trim($(txtPasswordConfirm).val());
        var a1	= $.trim($(txtAddress).val());
        var c	= $.trim($(txtCity).val());
        var z	= $.trim($(txtPostal).val());
        var t	= $.trim($(txtPhone).val());
        var r  = $.trim($(txtRCISCode).val());
        var homephone;

        var g = IREP.options.user.geoCode;

        if ((g == "APAC") || (g == "EMEA") || (g == "LAR")) {
            var sc	= "0";
        } else {
            var sc	= $(ddlCompany).val();
        }

        if (IREP.options.user.countryCode  == "BR") 
        {
            var brstate = $(ddlStateBrazil).val();
            var brcity = $(ddlCityBrazil).val();
        } 

        var upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var lower = upper.toLowerCase();
        var number = "1234567890";
        var special = "|[!\"#$%&'()*+,-./:;=>?@[\]^_`{|}~]";

        if (typeof pageLoad == "undefined") {
            hf = 1;
        }
        if (pageLoad == true) {
            hf = 0;
        }

        $("#divError").hide();

        if (sc == "-1") {
            var rcis = false;
            b = false;
            $("#divError").html(mtrRetailChainMissing);
            $("#divError").show();
        }
        
        if (e == "") {b = false;$("#divError").html(mtrEmailMissing);$("#divError").show();}

        if ((e.match(/\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/) == null)) {b = false;$("#divError").html(mtrIncorrectEmail);$("#divError").show();}
        if (pw != pc) {b = false;$("#divError").html(mtrPasswordNotMatch);$("#divError").show();}
        if ((pw != "") && (pc != "")) {
            if (pw.length < 6) {b = false;$("#divError").html(mtrPasswordMustBe);$("#divError").show();}
            if ((myContains(pw, upper) == false) && (myContains(pw, lower) == false)) {b = false;$("#divError").html(mtrPasswordMustBe);$("#divError").show();}
            if (myContains(pw, number) == false) {b = false;$("#divError").html(mtrPasswordMustBe);$("#divError").show();}
            if (myContains(pw, special) == false) {b = false;$("#divError").html(mtrPasswordMustBe);$("#divError").show();}
        }
        if ((cn.toLowerCase() == "us") || (cn.toLowerCase() == "ca")) {
            if (a1 == "") {b = false;$("#divError").html(mtrAddressMissing);$("#divError").show();}
            if (c == "") {b = false;$("#divError").html(mtrCityMissing);$("#divError").show();}
            if (z == "") {b = false;$("#divError").html(mtrZipCodeMissing);$("#divError").show();}
            if (t == "") {b = false; $("#divError").html(mtrPhoneMissing); $("#divError").show(); }
            homephone = $.trim($(txtHomePhone).val());
            if (homephone == "") { b = false; $("#divError").html(mtrPhoneMissing); $("#divError").show(); }
        }

        if (IREP.options.user.countryCode.toUpperCase() == "BR") {
            if (brcity == "") { b = false; $("#divError").html("* Cidade"); $("#divError").show(); }
            if (brstate == "") { b = false; $("#divError").html("* Estado"); $("#divError").show(); }
        }

        if ((g == "PRC") && (104 !== IREP.options.user.userTypeId)) {
            if ($(drpStoreApac).val() == null && IntelIdClicked == 0) { b = false; $("#divError").html("请填写商店。"); $("#divError").show(); }
            else if (IntelIdClicked == 1)
                if ($(drpStoreSearchApac).val() == "-1") { b = false; $("#divError").html("请填写商店。"); $("#divError").show(); }
        }

        CheckRows();
        return b;
    }

    var CheckRows = function () {

        var c = $(ddlCountry).val();
        var g = IREP.options.user.geoCode;
        if ((c.toLowerCase() == "us") || (c.toLowerCase() == "ca") || (g.toLowerCase() == "lar")) {
            ShowASMORows(g.toLowerCase() == "asmo");
        } else {
            HideASMORows();
        }
    }

    var ShowASMORows = function (showProvince) {

        $(trAddress).show();
        $(trAddress2).show();
        if (IREP.options.user.countryCode.toUpperCase() != "BR") {
            $(trCity).show();
        } 
        if (showProvince == true){
            $(trProvince).show();
        }
        else{
		    $(trProvince).hide();
        }
        $(trPostal).show();
    
    }

    var HideASMORows = function() {

        $(trAddress).hide();
        $(trAddress2).hide();
        if (IREP.options.user.countryCode.toUpperCase() != "BR") {
            $(trCity).hide();
        }
        $(trProvince).hide();
        $(trPostal).hide();
    }

    var myContains = function(password, validChars) {
        for (var i = 0; i < password.length; i++) {
            var char = password.charAt(i);
            if (validChars.indexOf(char) > -1) {
                return true;
            }
        }
        return false;
    }

    var GetProvinces = function() {
        var geo = IREP.options.user.geoCode;
        var optn;
        if ((geo == "PRC") && (104 !== IREP.options.user.userTypeId)) {
            $(drp2Province).empty();
            optn = document.createElement("option");
            optn.text = mtrPleaseSelect;
            optn.value = "-1";
            drp2Province.options.add(optn);
        }
        else{
            $(ddlProvince).empty();
        }
        var c = $(ddlCountry).val().toLowerCase();
        if ((c == "us") || (c == "ca") || ((geo == "PRC") && (104 !== IREP.options.user.userTypeId))){

            var data = {Country: c}
            IREP.callApi("provinces/getbycountry", "GET", data)
                .done(function (data) {
                    if (data != null) {
                        for (var i = 0; i < data.provinces.length; i++) {
                            optn = document.createElement("option");
                            optn.text = data.provinces[i].name;
                            optn.value = data.provinces[i].id;
                            $(ddlProvince).append(optn);
                        }
                    }
                })
                .fail(function () {
                })

                if ((geo == "PRC") && (104 !== IREP.options.user.userTypeId)) {
                    GetApacCities();
                }
        }
    }

    var GetStores = function () {
        var o = IREP.options.user.site == "ISEP";
        var c = $(ddlCountry).val();
        var sc = $(ddlCompany).val();
        var s = $(ddlStore);
        var dmr = IREP.options.user.site == "DMR";
        var name;
        var id;
        var optn;
        var brstate = 0;
        var brcity = 0;
        var br = false;
        if (IREP.options.user.countryCode == "BR") {
            br = true;
            brstate = $(ddlStateBrazil).val();
            brcity = $(ddlCityBrazil).val();
            if (brstate == "") { brstate = 0; }
            if (brcity == "") { brcity = 0; }
            }
        if ((br == false) || (sc > 0)) {
            var data = { countryCode: c, storeChainId: sc, isOEM: o, isDMR: dmr, stateId: brstate, cityId: brcity }
            IREP.callApi("retailers/stores/getbystorechain", "GET", data)
                .done(function (data) {
                    s.empty();
                    if (data.store != null) {
                        for (var i = 0; i < data.store.length; i++) {
                            optn = document.createElement("option");
                            optn.text = data.store[i].name;
                            optn.value = data.store[i].id;
                            s.append(optn);
                        }
                    }
                    if (br != true) {
                        optn = document.createElement("option");
                        optn.text = "Store not listed";
                        optn.value = "-1";
                        s.append(optn);
                    }
                })
                .fail(function () {
                })

        } else {
		    s.empty();
            optn = document.createElement("option");
            optn.text = mtrPleaseSelect;
            optn.value = "-1";
            s.append(optn);
        }
    }

    var GetStoreChains = function (storeChainId) {

        var site = IREP.options.user.site;
        var geo = IREP.options.user.geoCode;
        var sc;
        if ((geo == "PRC") && (104 !== IREP.options.user.userTypeId)) {
            sc = drpRetailerApac;
        } else {
            sc = ddlCompany;
        }
        var c = $(ddlCountry).val();
        if (typeof storeChainId == "undefined") {
            storeChainId = 0;
        }
        var name;
        var id;
        var optn;
        var rcis = false;
        var brstate = 0;
        var brcity = 0;
        var br = false;

        if (IREP.options.user.countryCode == "BR") {
		    br = true;
		    brstate = $(ddlStateBrazil).val();
		    brcity = $(ddlCityBrazil).val();
            if (brstate == "") { brstate = 0; }
            if (brcity == "") { brcity = 0; }
        }
        if ((br == true) && (storeChainId <= 0) && (brcity <= 0)) {
            $(sc).empty();
            optn = document.createElement("option");
            optn.text = mtrPleaseSelect;
            optn.value = "-1";
            $(sc).append(optn);
            GetStores();
        }
        if ((((rcis != true) || (storeChainId > 0)) && (br == false)) || ((br == true) && ((storeChainId > 0) || (brcity > 0)))) {

            var data = { countryCode: c, isTSP: (site == "SP"), storeChainId: storeChainId, isOEM: (site == "ISEP") };
            IREP.callApi("storechain/getbycountry", "GET", data)
                .done(function (data) {
                    $(sc).empty();
                    if (((geo == "PRC")) && (104 !== IREP.options.user.userTypeId)) {
                        optn = document.createElement("option");
                        optn.text = mtrPleaseSelect;
                        optn.value = "-1";
                        $(sc).append(optn);
                    }

                    if (data.storeChain != null) {
                        for (var i = 0; i < data.storeChain.length; i++) {
                            optn = document.createElement("option");
                            optn.text = data.storeChain[i].name;
                            optn.value = data.storeChain[i].id;
                            $(sc).append(optn);
                        }
                    }

                    if ((c.toLowerCase() != "us") && (c.toLowerCase() != "ca") && (br != true)) {
                        optn = document.createElement("option");
                        optn.text = mtrChainNotListed;
                        optn.value = "-1";
                        $(sc).append(optn);
                    }

                    if (geo == "PRC") {
                        GetApacStores();
                    } else {
                        GetStores();
                    }
                })
                .fail(function () {
                })

        }
    }

    var FilterByAddress = function() {
        IntelIdClicked = 0;

        $("#divAddress").css("background-color", "#FFC50C");
        $("#divAddress").css("border-top-left-radius", "5px");
        $("#divAddress").css("border-top-right-radius", "5px");

        $("#divIntelId").css("background-color", "transparent");
        $("#divIntelId").css("border-top-left-radius", "0px");
        $("#divIntelId").css("border-top-right-radius", "0px");

        $("#txtIntelId").val("");

        $("#tblAPACSearch").css("display", "none");
        $("#tblAPACFilter").css("display", "block");
    }

    var FilterByIntelId = function() {
        IntelIdClicked = 1;
        $("#divIntelId").css("background-color", "#FFC50C");
        $("#divIntelId").css("border-top-left-radius", "5px");
        $("#divIntelId").css("border-top-right-radius", "5px");

        $("#divAddress").css("background-color", "transparent");
        $("#divAddress").css("border-top-left-radius", "0px");
        $("#divAddress").css("border-top-right-radius", "0px");

        $("#txtIntelId").val("");

        $("#tblAPACSearch").css("display", "block");
        $("#tblAPACFilter").css("display", "none");

    }

    var GetAsmoStores = function () {
        //alert('need to implement get asmo stores');
    }

    var GetApacStores = function () {
        var p = $(drp2Province).val();
        var pn = $(drp2Province + ' :selected').text();
        var c = $(drpStoreApac);
        var c2 = $(ddlCountry).val();
        var city = $(drp2City).val();
        var sc = $(drpRetailerApac).val();
        var scn = $(drpRetailerApac + ' :selected').text();
        c.empty();
        optn = document.createElement("option");
        optn.text = "...";
        optn.value = "-1";
        c.append(optn);
        var optn;


        if ((IREP.options.user.geoCode == "PRC") && (IREP.options.user.UserTypeId != 104))
        {
            var data = { countryCode: c2, storeChainId: sc, storeChainName: scn, provinceId: p, provinceName: pn, city: city }
            IREP.callApi("retailers/stores/getapacstores", "GET", data)
                .done(function (data) {
                    if (data.store != null) {
                        c.empty();
                        optn.text = "请选择......";
                        optn.value = "-1";
                        c.append(optn);
                        for (var i = 0; i < data.store.length; i++) {
                            optn = document.createElement("option");
                            optn.text = data.store[i].name;
                            optn.value = data.store[i].id;
                            c.append(optn);
                        }
                        if (IREP.options.user.geoCode != 'PRC') {
                            optn = document.createElement("option");
                            optn.text = "Store Not Listed";
                            optn.value = "1";
                            c.append(optn);
                        }
                    }
                })
                .fail(function () {
                })
        }
    }

    var GetApacCities = function () {
        var p = $(drp2Province).find('option:selected').text();
        var c = $(drp2City);
        var g = IREP.options.user.geoCode;
        var c2 = $(ddlCountry).val();
        var optn;
        c.empty();
        optn = document.createElement("option");
        optn.text = mtrPleaseSelect;
        optn.value = mtrPleaseSelect;
        c.append(optn);

        var data = { geo: g, country: c2, state: p }
        IREP.callApi("retailers/stores/getcities", "GET", data)
            .done(function (data) {
                if (data.store != null) {
                    for (var i = 0; i < data.store.length; i++) {
                        optn = document.createElement("option");
                        optn.text = data.store[i].name;
                        optn.value = data.store[i].name;
                        $(c).append(optn);
                    }
                    GetApacStores();
                }
            })
            .fail(function () {
            })

    }

    var ShowStoreInfo = function () {
        //alert('need to implement show store info');
    }

    var ClearFilters = function () {
        GetStoreChains();
        $(drp2Province).prop('selectedIndex', 0);
        $(drp2City).prop('selectedIndex', 0);
        $(drpRetailerApac).prop('selectedIndex', 0);
        $(drpStoreApac).prop('selectedIndex', 0);
        $("#APACStoreInfo").hide();
        //ClearAPACStore();
    }

    var ClearIntelIdPRCStores = function() {
        $('#txtIntelId').val('');
        var c = $(drpStoreSearchApac);
        c.empty();
        var optn = document.createElement("option");
        optn.text = "...";
        optn.value = "-1";
        c.append(optn);
    }

    var GetPRCStoresbyIntelId = function() {
        var scn = $('#txtIntelId').val();
        var c = $(drpStoreSearchApac);
        var optn;
        c.empty();
        optn = document.createElement("option");
        optn.text = "...";
        optn.value = "-1";
        c.append(optn);

        var data = { storeCode: scn }
        IREP.callApi("retailers/stores/getprcstoresbystorecode", "GET", data)
            .done(function (data) {
                if (data.store != null) {
                    c.empty();
                    optn = document.createElement("option");
                    optn.text = mtrPleaseSelect;
                    optn.value = "-1";
                    c.append(optn);
                    for (var i = 0; i < data.store.length; i++) {
                        optn = document.createElement("option");
                        optn.text = data.store[i].name;
                        optn.value = data.store[i].id;
                        $(c).append(optn);
                    }

                    if (IREP.options.user.geoCode != 'PRC') {
                        optn = document.createElement("option");
                        optn.text = "Store Not Listed";
                        optn.value = "1";
                        c.append(optn);
                    }
                }
            })
            .fail(function () {
            })
    }

    var GetBrazilCities = function () {

        var province = $(ddlStateBrazil).find('option:selected').val();
        var city = $(ddlCityBrazil);
        var optn;

        var data = { provinceid: province }
        IREP.callApi("cities/brazil/getbyprovince", "GET", data)
            .done(function (data) {
                city.empty();
                optn = document.createElement("option");
                optn.text = "Selecionar...";
                optn.value = "";
                city.append(optn);
                if (data.city != null) {
                    for (var i = 0; i < data.city.length; i++) {
                        optn = document.createElement("option");
                        optn.text = data.city[i].name;
                        optn.value = data.city[i].id;
                        $(city).append(optn);
                    }
                }
            })
            .fail(function () {
            })
    }

    return {
        init: init,
        AccountCheck: AccountCheck,
        HideASMORows: HideASMORows,
        GetStores: GetStores,
        GetStoreChains: GetStoreChains,
        GetAsmoStores: GetAsmoStores,
        GetApacStores: GetApacStores,
        ShowStoreInfo: ShowStoreInfo,
        ClearFilters: ClearFilters,
        GetBrazilCities: GetBrazilCities,
        GetProvinces: GetProvinces,
        CheckRows: CheckRows,
        FilterByAddress: FilterByAddress,
        FilterByIntelId: FilterByIntelId,
        GetApacCities: GetApacCities,
        ClearIntelIdPRCStores: ClearIntelIdPRCStores,
        GetPRCStoresbyIntelId: GetPRCStoresbyIntelId
    };
})();